import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const version = 'v1';

export function usePublicoService() {
  const { backendGet } = Sebrae.useBackend();

  const getObterPublico = React.useCallback(
    () => backendGet(`${version}/publicos`),
    [backendGet],
  );

  return {
    getObterPublico,
  };
}
